"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Capacity = void 0;
const memoizee_1 = __importDefault(require("memoizee"));
const CapacityPeriod_1 = require("./CapacityPeriod");
const PeriodCalculator_1 = require("./PeriodCalculator");
const TeamCapacity_1 = require("./TeamCapacity");
class Capacity {
    constructor(year, month, engineer, region) {
        this.year = year;
        this.month = month;
        this.engineer = engineer;
        this.region = region;
        this.getRegionCapacityPeriod = (0, memoizee_1.default)(() => this.regionHandle.getUtilizationPeriod(this.fromDate, this.toDate));
        if ((engineer.region || "") !== region.id) {
            throw new Error("illegal region");
        }
        this.fromDate = new Date(this.year, this.month, 1);
        this.toDate = new Date(this.year, this.month + 1, 0);
        this.regionHandle = region;
        this.utilizations = this.engineer.getCapacities(year, month);
    }
    getUtilizations() {
        return this.engineer.getCapacities(this.year, this.month);
    }
    getTeamsSet() {
        return this.getUtilizations().reduce((set, u) => {
            if (u.team) {
                set.add(u.team);
            }
            return set;
        }, new Set());
    }
    getTeams() {
        return Array.from(this.getTeamsSet());
    }
    isInTeam(teamId) {
        return this.getTeamsSet().has(teamId);
    }
    isEmpty() {
        return this.getCapacityPeriods().length < 1;
    }
    getCapacityPeriods() {
        const utilizations = this.getUtilizations();
        const periods = (0, PeriodCalculator_1.calculatePeriods)(utilizations, (u) => new Date(u.year, u.month, u.day), this.toDate)
            .filter((item) => item.item.percent > 0)
            .map((item) => {
            const fromDate = new Date(Math.max(this.fromDate.getTime(), item.from.getTime()));
            const toDate = new Date(Math.min(this.toDate.getTime(), item.to.getTime()));
            const regionUtilization = this.regionHandle.getUtilizationPeriod(fromDate, toDate);
            return new CapacityPeriod_1.CapacityPeriod(item.item.team, regionUtilization, item.item.percent);
        });
        return periods;
    }
    getGrossUtilizationHours() {
        return this.getCapacityPeriods().reduce((total, u) => total + u.getCapacityHours(), 0);
    }
    getGrossUtilizationHours1850() {
        return this.getCapacityPeriods().reduce((total, u) => total + u.getCapacityHours1850(), 0);
    }
    getUtilizationHours() {
        const hours = this.getGrossUtilizationHours();
        const timeOff = this.engineer.getDaysOff(this.year, this.month);
        const timeOffHours = this.getCapacityPeriods().reduce((total, u) => total + (u.percent / 100) * timeOff * 8, 0);
        const total = Math.max(hours - timeOffHours, 0);
        return total;
    }
    getUtilizationHours1850() {
        return this.getGrossUtilizationHours1850();
    }
    getTeamUtilizations() {
        const teamIds = this.getCapacityPeriods().reduce((ids, period) => {
            ids.add(period.team);
            return ids;
        }, new Set());
        return Array.from(teamIds).map((teamId) => this.getTeamUtilization(teamId));
    }
    getTeamUtilizations1850() {
        const teamIds = this.getCapacityPeriods().reduce((ids, period) => {
            ids.add(period.team);
            return ids;
        }, new Set());
        return Array.from(teamIds).map((teamId) => this.getTeamUtilization1850(teamId));
    }
    getTeamUtilization(teamId) {
        const periods = this.getCapacityPeriods().filter((u) => u.team === teamId);
        const timeOff = this.engineer.getDaysOff(this.year, this.month);
        return new TeamCapacity_1.TeamCapacity(this.year, this.month, this.engineer, teamId, this.region, periods, timeOff);
    }
    getTeamUtilization1850(teamId) {
        const periods = this.getCapacityPeriods().filter((u) => u.team === teamId);
        const timeOff = this.engineer.getDaysOff(this.year, this.month);
        return new TeamCapacity_1.TeamCapacity(this.year, this.month, this.engineer, teamId, this.region, periods, timeOff);
    }
    getDaysOff() {
        return this.engineer.getDaysOff(this.year, this.month);
    }
    getHolidays() {
        return this.getRegionCapacityPeriod().holidays.length;
    }
    getWeekdays() {
        return this.getRegionCapacityPeriod().weekdays;
    }
}
exports.Capacity = Capacity;
//# sourceMappingURL=Capacity.js.map